<script setup>
import { toRefs, computed } from 'vue';
import { useClipboard } from '@vueuse/core';

import { useToast } from 'cc-prime';

const toast = useToast();
const props = defineProps({
  code: {
    type: [String, Object],
  },
});
const { code } = toRefs(props);

const { copy } = useClipboard();

function copyAndShowToast(text) {
  copy(text);
  toast.add({
    severity: 'success',
    detail: 'Copied to clipboard',
    life: 3000,
  });
}

const formattedCode = computed(() => {
  return typeof code.value === 'object'
    ? JSON.stringify(code.value, null, 2)
    : code.value;
});
</script>

<template>
  <div
    v-if="code"
    class="relative w-full rounded-xl bg-surface-0 px-4 py-4 pr-10 text-gray-500 dark:bg-surface-700 dark:text-gray-300"
  >
    <span class="absolute end-0 top-0">
      <Button
        class="!rounded-xl !bg-surface-0 !px-4 transition-colors duration-200 hover:!bg-surface-100 dark:!bg-surface-700 hover:dark:!bg-surface-600"
        text
        @click="copyAndShowToast(formattedCode)"
        severity="secondary"
        size="large"
      >
        <i class="icon-[solar--copy-linear] text-xl text-primary-500" />
      </Button>
    </span>
    <div class="max-h-full overflow-auto">
      <pre><code class="text-base">{{formattedCode}}</code></pre>
    </div>
  </div>
</template>
